import {CollectionPreferencesProps} from "@amzn/awsui-components-react-v3";
import {
    CABLING_MANIFEST_TABLE_CONSTANT,
    PLANNED_DELIVERIES_PAGE,
    REFERENCE_ID_ENUM
} from "../LmdpConstants";
import {
    Delivery
} from "../common/GetDeliveriesDetailsGQLResponse";
import {getHumanReadableUTCDate, getISOWeek, getIsoWeekFromEpoch, sortInstantComparator, sortStringComparator} from "../../../util/DateUtil";
import {CablingManifestTabTableByCablingStatus} from "./interface/CablingManifestTabTableByCablingStatus";
import {TableColumnConfigWithoutCsv} from "../common/TableColumnConfig";
import { TableColumnConfigCommon } from "../common/TableColumnConfig";
import { DATE_FORMAT } from "../../../util/ConfigConstants";
import {determineStatusType} from "../common/LmdpUtil";
import {getStatusIndicator} from "../../../util/StatusIndicatorHelper";

export const CABLING_TAB_TABLE_COLUMN_CONFIG: ReadonlyArray<TableColumnConfigWithoutCsv<CablingManifestTabTableByCablingStatus>> = [

    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.SITE_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.SITE_LABEL,
        cell: (item: CablingManifestTabTableByCablingStatus) => item.site || '-',
        isVisible: true,
        minWidth: 250
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.WEEK_1,
        header: getISOWeek(0) + " (Current)",
        cell: (item: CablingManifestTabTableByCablingStatus) => item.weekWiseCount.at(0),
        isVisible: true,
        minWidth: 250
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.WEEK_2,
        header: getISOWeek(1),
        cell: (item: CablingManifestTabTableByCablingStatus) => item.weekWiseCount.at(1),
        isVisible: true,
        minWidth: 250
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.WEEK_3,
        header: getISOWeek(2),
        cell: (item: CablingManifestTabTableByCablingStatus) => item.weekWiseCount.at(2),
        isVisible: true,
        minWidth: 250
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.TOTAL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TABLE.TOTAL,
        cell: (item: CablingManifestTabTableByCablingStatus) => item.totalCount,
        isVisible: true,
        minWidth: 250,
    }
]

export const CABLING_TABLE_RAW_COLUMN_CONFIG : ReadonlyArray<TableColumnConfigCommon<Delivery>> = [
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.DEMAND_ID_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.DEMAND_ID_LABEL,
        cell: (item) => item.demandId,
        isVisible: true,
        minWidth: 320,
        csvText:(item) => item.demandId,
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.ASSET_ID_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.ASSET_ID_LABEL,
        cell: (item) =>  item?.assetId || '-',
        isVisible: true,
        minWidth: 130,
        csvText: (item) => (item?.assetId || '-'),
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.AZ_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.AZ_LABEL,
        cell: (item) => item?.az,
        isVisible: true,
        minWidth: 140,
        csvText:(item) => item?.az,
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(i1.az,i2.az),
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.SITE_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.SITE_LABEL,
        cell: (item) => item?.site || '-',
        isVisible: true,
        minWidth: 130,
        csvText:(item) => item?.site || '-',
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(i1.site,i2.site),
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.PO_LOCATION_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.PO_LOCATION_LABEL,
        cell: (item) => item?.positionLocation || '-',
        isVisible: true,
        minWidth: 160,
        csvText:(item) => item?.positionLocation || '-',
        hoursToUpdate: "1"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.CABLING_STATUS_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.CABLING_STATUS_LABEL,
        cell: (item) => getStatusIndicator(item.cablingStatus, determineStatusType),
        isVisible: true,
        minWidth: 230,
        csvText:(item) => item?.cablingStatus || '-',
        hoursToUpdate: "1"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.CLUSTER_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.CLUSTER_LABEL,
        cell: (item) => item.cluster,
        isVisible: false,
        minWidth: 135,
        csvText:(item) => item.cluster,
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RACK_GROUP_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RACK_GROUP_LABEL,
        cell: (item) => item?.rackGroup,
        isVisible: true,
        minWidth: 140,
        csvText:(item) => item?.rackGroup,
        hoursToUpdate: "1"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RACK_TYPE_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RACK_TYPE_LABEL,
        cell: (item) => (item?.rackType) || '-',
        isVisible: true,
        minWidth: 150,
        csvText:(item) => item?.rackType || '-',
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(i1.rackType,i2.rackType),
        hoursToUpdate: "6"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.UPLINK_CONFIG_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.UPLINK_CONFIG_LABEL,
        cell: (item) => item?.uplinkConfig,
        isVisible: true,
        minWidth: 140,
        csvText:(item) => item?.uplinkConfig,
        hoursToUpdate: "1"
    },
    {
        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RATS_CONFIRMATION_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.RATS_CONFIRMATION_LABEL,
        cell: (item) => item?.ratsConfirmation,
        isVisible: false,
        minWidth: 140,
        csvText:(item) => item?.ratsConfirmation,
        hoursToUpdate: "6"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TARGET_DELIVERY_DATE_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.TARGET_DELIVERY_DATE_LABEL,
        cell: (item) => getIdByType(REFERENCE_ID_ENUM.TDD, item),
        isVisible: true,
        minWidth: 140,
        csvText:(item) => getIdByType(REFERENCE_ID_ENUM.TDD, item),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(getIdByType(REFERENCE_ID_ENUM.TDD, i1), getIdByType(REFERENCE_ID_ENUM.TDD, i2)),
        hoursToUpdate: "6"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.BRICK_HANDOFF_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.BRICK_HANDOFF_LABEL,
        cell: (item) => getIdByType(REFERENCE_ID_ENUM.BRICK, item),
        isVisible: true,
        minWidth: 140,
        csvText:(item) => getIdByType(REFERENCE_ID_ENUM.BRICK, item),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(getIdByType(REFERENCE_ID_ENUM.BRICK, i1), getIdByType(REFERENCE_ID_ENUM.BRICK, i2)),
        hoursToUpdate: "6"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.BRICK_HANDOFF_DATE_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.BRICK_HANDOFF_DATE_LABEL,
        cell: (item) => getIdByType(REFERENCE_ID_ENUM.BRICK_HANDOFF_DATE, item),
        isVisible: true,
        minWidth: 140,
        csvText:(item) => getIdByType(REFERENCE_ID_ENUM.BRICK_HANDOFF_DATE, item),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(getIdByType(REFERENCE_ID_ENUM.BRICK_HANDOFF_DATE, i1), getIdByType(REFERENCE_ID_ENUM.BRICK_HANDOFF_DATE, i2)),
        hoursToUpdate: "6"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.POSITION_HANDOFF_DATE_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.POSITION_HANDOFF_DATE_LABEL,
        cell: (item) => getIdByType(REFERENCE_ID_ENUM.POSITION_HANDOFF_DATE, item),
        isVisible: true,
        minWidth: 140,
        csvText:(item) => getIdByType(REFERENCE_ID_ENUM.POSITION_HANDOFF_DATE, item),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(getIdByType(REFERENCE_ID_ENUM.POSITION_HANDOFF_DATE, i1), getIdByType(REFERENCE_ID_ENUM.POSITION_HANDOFF_DATE, i2)),
        hoursToUpdate: "6"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.PROMISE_DATE,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.PROMISE_DATE,
        cell: (item) => getIdByType(REFERENCE_ID_ENUM.PROMISE_DATE, item),
        isVisible: true,
        minWidth: 140,
        csvText:(item) => getIdByType(REFERENCE_ID_ENUM.PROMISE_DATE, item),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortStringComparator(getIdByType(REFERENCE_ID_ENUM.PROMISE_DATE, i1), getIdByType(REFERENCE_ID_ENUM.PROMISE_DATE, i2)),
        hoursToUpdate: "2"
    },
    {
        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.ESTIMATED_DELIVERY_DATE_LABEL,
        header: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.ESTIMATED_DELIVERY_DATE_LABEL,
        cell: (item) => getHumanReadableUTCDate(item.calculatedDeliveryDate.startDate.toString(), DATE_FORMAT),
        isVisible: true,
        minWidth: 180,
        csvText:(item) => getHumanReadableUTCDate(item.calculatedDeliveryDate.startDate.toString(), DATE_FORMAT),
        sortingComparator: (i1: Delivery, i2: Delivery) => sortInstantComparator(i1.calculatedDeliveryDate.startDate.toString(),i2.calculatedDeliveryDate.startDate.toString()),
        hoursToUpdate: "4"
    },
    {

        label: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.ISO_WEEK_LABEL,
        header: PLANNED_DELIVERIES_PAGE.RESULT.TABLE.ISO_WEEK_LABEL,
        cell: (item) => getIsoWeekFromEpoch(item.calculatedDeliveryDate.startDate),
        isVisible: true,
        minWidth: 210,
        csvText:(item) => getIsoWeekFromEpoch(item.calculatedDeliveryDate.startDate),
        sortingComparator: (item1, item2) => sortStringComparator(
            getIsoWeekFromEpoch(item1.calculatedDeliveryDate.startDate),
                getIsoWeekFromEpoch(item2.calculatedDeliveryDate.startDate)),
          hoursToUpdate: "6"
    }
]

export const CABLING_RAW_TABLE_CONTENT_SELECTOR_OPTIONS: ReadonlyArray<CollectionPreferencesProps.VisibleContentOption> = CABLING_TABLE_RAW_COLUMN_CONFIG.map(columnConfig => {
    return {id: columnConfig.label, label: columnConfig.label}
})

export const CABLING_TABLE_VISIBLE_COLUMNS: ReadonlyArray<string> = CABLING_TAB_TABLE_COLUMN_CONFIG.filter(column => column.isVisible)
    .map(column => column.label)

export const CABLING_RAW_TABLE_VISIBLE_COLUMNS: ReadonlyArray<string> = CABLING_TABLE_RAW_COLUMN_CONFIG.filter(column => column.isVisible)
    .map(column => column.label)

function getIdByType(idType: string, data: Delivery) {
    const referenceIdWithIdType = data.referenceIds?.find(item => item.idType === idType);
    return referenceIdWithIdType ? referenceIdWithIdType.id : "-";  
}